import moment from 'moment/moment';
import parameters from '../config/parameters';



// class Helper {
//     static roundNumber(value, decimals) {
//         return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
//     }

// }
// export default Helper;

const messageTypes = {
    ACCOUNT_PRIVILEGE_CHANGE: "accountPrivilegeChange",
    REMOVE_FROM_CLUB: 'removeFromClub',
    JOIN_REQUEST: 'joinRequest',
    JOINED_TO_CLUB: "joinedToClub",
    BALANCE_UPDATE: "balanceUpdate",
    PRODUCT_EXPIRATION: 'productExpiration',
    LEVEL_EXPIRATION: 'levelExpiration',
}

export const messageConverter = (msg) => {
    if(!Object.keys(msg).length || !msg.templateId || !msg.data) {
        return;
    }
    const tmpId = msg.templateId;
    const data = msg.data;
    const message = tmpId;

    if(!message) {
        return;
    }
    let content = {};
    if(tmpId == messageTypes.ACCOUNT_PRIVILEGE_CHANGE) {
        if(!data.clubName || !data.roleId) {
            return;
        }
        content.param1 = data.clubName;
        content.param2 = parameters.accountTypeIds[data.roleId];
    } else if(tmpId == messageTypes.JOIN_REQUEST) {
        if(!data.skin || !data.player || !data.skin.username || !data.player.username) {
            return;
        }
        content.param1 = data.skin.username;
        content.param2 = data.player.username;
    } else if(tmpId == messageTypes.BALANCE_UPDATE) {
        if(!data.club || !data.club.username || !data.balance || !data.currency) {
            return;
        }
        content.param1 = data.club.username;
        content.param2 = data.balance;
    } else if(tmpId == messageTypes.PRODUCT_EXPIRATION) {
        if(!data.productName || !data.expirationDate) {
            return;
        }
        const expirationDate = moment(data.expirationDate).format('YYYY.MM.DD');
        content.param1 = data.productName;
        content.param2 = expirationDate;
    } else if(tmpId == messageTypes.JOINED_TO_CLUB) {
        if(!data.skin || !data.skin.username) {
            return;
        }
        content.param1 = data.skin.username;
    } else if(tmpId == messageTypes.LEVEL_EXPIRATION) {
        if(!data.expirationDate) {
            return;
        }
        const expirationDate = moment(data.expirationDate).format('YYYY.MM.DD');
        content.param1 = expirationDate;
    } else if(tmpId == messageTypes.REMOVE_FROM_CLUB) {
        if(!data.clubName) {
            return;
        }
        content.param1 = data.clubName;
    }

    content.text = `messages.${message}.body`;
    msg.header = `messages.${message}.header`;
    msg.content = content;
    
    return msg;
}
